import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './SuccessStories.css';

const SuccessStories = () => {
  const clientLogos = [
    '/client-logo-1.png',
    '/client-logo-2.png',
    '/client-logo-3.png',
    '/client-logo-4.png',
    '/client-logo-5.png',
    '/client-logo-6.png',
    '/client-logo-7.png',
    '/client-logo-8.png', // Add more if needed to ensure continuous scroll effect
  ];

  return (
    <section id="casos-de-exito" className="success-stories-section">
      <Container>
        {/* Carrusel de Logos de Clientes */}
        <h3 className="text-center mb-4">Nuestros Clientes Destacados</h3>
        <div className="client-logos-carousel">
          <div className="client-logos-carousel-inner">
            {/* Duplicate logos to create continuous effect */}
            {clientLogos.concat(clientLogos).map((logo, index) => (
              <div className="logo-item" key={index}>
                <img src={logo} alt={`Client Logo ${index + 1}`} className="img-fluid" />
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default SuccessStories;
